import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CircularProgress from "@mui/material/CircularProgress";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

const styles = {
  submitButton: {
    mr: "1px",
    height: 36,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  dropdownButton: {
    px: 0,
    height: 36,
    minWidth: 40,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
};

function InventoryTypeModal({ open, onClose, onSelect }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', color: 'black', fontSize: '1.2rem', fontWeight: 500, pb: 6 }}>
        Select Inventory Type
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="row" gap={1.5} pb={2}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => onSelect('onsite_inventory')}
          >
            Onsite Inventory
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => onSelect('in_progress')}
          >
            Warehouse Inventory
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default function ActionsButton({ loading, onClick, project }) {
  const isOnsiteManifest = project?.settings?.onsite_manifest;
  const showOnsiteInventory = project?.settings?.onsite_capture_to_warehouse_storage;
  const [modalOpen, setModalOpen] = useState(false);

  const handleSelect = (shipmentStatus) => {
    setModalOpen(false);
    onClick({ shipmentStatus });
  };

  if (showOnsiteInventory) {
    return (
      <>
        <Button
          disabled={loading}
          type="button"
          variant="contained"
          color="primary"
          startIcon={loading && <CircularProgress size={22} />}
          onClick={() => setModalOpen(true)}
        >
          Start
        </Button>
        <InventoryTypeModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onSelect={handleSelect}
        />
      </>
    );
  }

  if (isOnsiteManifest) {
    return (
      <Button
        disabled={loading}
        type="button"
        variant="contained"
        color="primary"
        startIcon={loading && <CircularProgress size={22} />}
        onClick={() => onClick({ shipmentStatus: 'onsite_inventory' })}
      >
        Start
      </Button>
    );
  }

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <Button
        disabled={loading}
        type="button"
        sx={styles.submitButton}
        variant="contained"
        color="primary"
        startIcon={loading && <CircularProgress size={22} />}
        onClick={() => onClick({ shipmentStatus: 'in_progress' })}
      >
        Start
      </Button>
      <Box variant="contained" aria-label="split button">
        <PopupState variant="popover" popupId="demo-popup-menu">
          {popupState => (
            <React.Fragment>
              <Button
                variant="contained"
                color="primary"
                data-id="receiving-wizard-actions-dropdown"
                {...bindTrigger(popupState)}
                sx={styles.dropdownButton}
              >
                <KeyboardArrowDownIcon
                  sx={{ transform: popupState.open ? undefined : "rotate(180deg)" }}
                />
              </Button>
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  onClick={() => {
                    onClick({ shipmentStatus: 'draft' });
                    popupState.close();
                  }}
                >
                  Create Draft
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
      </Box>
    </Box>
  );
}
